/** Bounded product research vocabulary shared by browser, API and offline evals. */
const STAGES = /** @type {const} */ (['registration', 'ai', 'purchase']);
const REASONS = /** @type {const} */ (['unclear_value', 'missing_feature', 'price', 'trust', 'technical_problem', 'just_exploring', 'other']);
const FEATURES = /** @type {const} */ (['integrations', 'exports', 'cost_estimates', 'architecture_detail', 'collaboration', 'other']);
const EVENTS = {
    AUTH_STARTED: 'auth_started', AUTH_RETURNED: 'auth_returned', AUTH_READY: 'auth_ready', AUTH_FAILED: 'auth_failed',
    /** Guest clicked Sign in / create account (before MSAL). Distinct from AUTH_STARTED. */
    SIGN_UP_INTENT: 'sign_up_intent',
    AI_STARTED: 'ai_request_started', AI_FINISHED: 'ai_request_finished',
    PAYWALL_VIEW: 'paywall_view', PRICING_VIEW: 'pricing_view',
    /** Explicit paywall button (sign_in | pack_pass | pro | enterprise | feedback). */
    PAYWALL_CTA: 'paywall_cta_clicked',
    CHECKOUT_INTENT: 'checkout_intent', CHECKOUT_READY: 'checkout_redirect_ready',
    CHECKOUT_FAILED: 'checkout_failed', CHECKOUT_CANCELLED: 'checkout_cancelled',
    FEEDBACK_OPENED: 'product_feedback_opened', FEEDBACK_SENT: 'product_feedback_submitted',
};
const AI_ACTIONS = ['agentic_chat', 'architecture_desk', 'generate_agnostic_blueprint', 'generate_engagement_pack',
    'generate_technologist_advisory', 'generate_gap_close_proposal', 'architect_chat', 'explain_choice',
    'job_description', 'market_benchmark', 'generate_architecture'];
function errorReason(error) {
    if (error?.data?.code === 'RETRIEVAL_GATE_CLOSED') return 'grounding';
    if (error?.data?.code === 'AI_QUOTA_EXCEEDED') return 'quota';
    const status = Number(error?.status);
    if (status === 401) return 'authentication';
    if (status === 403) return 'access_denied';
    if (status === 429) return 'limit';
    if (status >= 500) return 'server';
    if (status >= 400) return 'invalid_request';
    if (error?.name === 'NetworkError' || error?.name === 'TypeError') return 'network';
    if (error?.name === 'AbortError' || error?.errorCode === 'user_cancelled') return 'cancelled';
    return 'unknown';
}
function errorOutcome(error) {
    const reason = errorReason(error);
    if (reason === 'grounding') return 'refused';
    if (['authentication', 'access_denied', 'quota', 'limit'].includes(reason)) return 'blocked';
    return reason === 'cancelled' ? 'cancelled' : 'error';
}
function aiOutcome(data) {
    if (data?.grounding?.open === false) return 'refused';
    if (data?.degraded
        || [data?.packSource, data?.advisorySource, data?.proposalSource].includes('fallback')
        || ['pattern_scaffold', 'composed_scaffold'].includes(data?.blueprintSource)) return 'fallback';
    if (data?.success === false) return 'error';
    return 'success';
}
function checkoutCancellationForRoute(path, search) {
    const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || '');
    if (params.get('payment') !== 'cancelled') return null;
    if (path === '/pricing') return { sku: 'Pro', source: 'pricing_return' };
    if (path === '/agentic' || String(path || '').startsWith('/agentic/')) {
        return { sku: 'pack_pass', source: 'agentic_return' };
    }
    return null;
}
function requestContext(url, body) {
    if (url === '/api/generateAiContent') return {
        kind: 'ai', action_type: AI_ACTIONS.includes(body?.actionType) ? body.actionType : 'other',
    };
    if (url === '/api/stripe/create-checkout') return { kind: 'checkout', sku: body?.sku === 'pack_pass' ? 'pack_pass' : 'Pro' };
    return null;
}
module.exports = { STAGES, REASONS, FEATURES, EVENTS, AI_ACTIONS, errorReason, errorOutcome, aiOutcome, checkoutCancellationForRoute, requestContext };
